(() => {
  const SELECTOR = '[data-pc394-nav]';
  const OPEN_DELAY = 340;
  const CLOSE_DELAY = 240;
  const TRANSITION_MS = 160;

  const init = (nav) => {
    if (!nav || nav.dataset.pc394Bound === 'true') return;
    nav.dataset.pc394Bound = 'true';

    const items = [...nav.querySelectorAll('[data-pc394-item]')];
    const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');
    let current = null;
    let openTimer = 0;
    let closeTimer = 0;

    const clearTimers = () => {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
    };

    const getParts = (item) => ({
      trigger: item?.querySelector('[data-pc394-trigger]') || null,
      panel: item?.querySelector('[data-pc394-panel]') || null,
    });

    const hidePanel = (item, returnFocus = false) => {
      if (!item) return;
      const { trigger, panel } = getParts(item);
      if (!trigger || !panel) return;

      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.classList.remove('is-open');
      nav.classList.remove('has-open-panel');

      window.setTimeout(() => {
        if (!item.classList.contains('is-open')) panel.hidden = true;
      }, TRANSITION_MS);

      if (current === item) current = null;
      if (returnFocus) trigger.focus({ preventScroll: true });
    };

    const showPanel = (item, focusFirst = false) => {
      if (!item) return;
      const { trigger, panel } = getParts(item);
      if (!trigger || !panel) return;

      clearTimers();
      if (current && current !== item) hidePanel(current, false);
      current = item;
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      nav.classList.add('has-open-panel');

      requestAnimationFrame(() => {
        item.classList.add('is-open');
        panel.classList.add('is-open');
        if (focusFirst) {
          const firstLink = panel.querySelector('a[href]');
          if (firstLink) firstLink.focus({ preventScroll: true });
        }
      });
    };

    const scheduleOpen = (item) => {
      clearTimers();
      openTimer = window.setTimeout(() => showPanel(item, false), OPEN_DELAY);
    };

    const scheduleClose = (item) => {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => hidePanel(item, false), CLOSE_DELAY);
    };

    items.forEach((item, index) => {
      const { trigger, panel } = getParts(item);
      if (!trigger || !panel) return;

      trigger.addEventListener('click', () => {
        clearTimers();
        if (item.classList.contains('is-open')) hidePanel(item, false);
        else showPanel(item, false);
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          showPanel(item, true);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          hidePanel(item, true);
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          const step = event.key === 'ArrowRight' ? 1 : -1;
          const triggers = items.map((entry) => entry.querySelector('[data-pc394-trigger], .pc394-nav__link')).filter(Boolean);
          const here = triggers.indexOf(trigger);
          if (here >= 0) triggers[(here + step + triggers.length) % triggers.length].focus();
        }
      });

      panel.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          hidePanel(item, true);
        }
      });

      item.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!item.contains(document.activeElement)) hidePanel(item, false);
        }, 0);
      });

      item.addEventListener('mouseenter', () => {
        if (hoverCapable.matches) scheduleOpen(item);
      });

      item.addEventListener('mouseleave', () => {
        if (hoverCapable.matches) scheduleClose(item);
      });
    });

    document.addEventListener('pointerdown', (event) => {
      if (current && !nav.contains(event.target)) hidePanel(current, false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && current) hidePanel(current, true);
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth < 990 && current) hidePanel(current, false);
    }, { passive: true });
  };

  const boot = () => document.querySelectorAll(SELECTOR).forEach(init);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
